'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _blockRendererFn = require('./blockRendererFn');

var _blockRendererFn2 = _interopRequireDefault(_blockRendererFn);

var _blockRenderMap = require('./blockRenderMap');

var _blockRenderMap2 = _interopRequireDefault(_blockRenderMap);

var _keyBindingFn = require('./keyBindingFn');

var _keyBindingFn2 = _interopRequireDefault(_keyBindingFn);

var _handleKeyCommand = require('./handleKeyCommand');

var _handleKeyCommand2 = _interopRequireDefault(_handleKeyCommand);

var _handleBeforeInput = require('./handleBeforeInput');

var _handleBeforeInput2 = _interopRequireDefault(_handleBeforeInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
    return {
        blockRendererFn: _blockRendererFn2.default,
        blockRenderMap: _blockRenderMap2.default,
        keyBindingFn: _keyBindingFn2.default,
        handleKeyCommand: _handleKeyCommand2.default,
        // TODO Maybe move this into the markdown plugin
        handleBeforeInput: _handleBeforeInput2.default
    };
}; // Helpers


//////////////////
// WEBPACK FOOTER
// ./src/client/components/editor/plugins/checklist/index.js
// module id = 1724
// module chunks = 0